import { useMemo } from 'react';

import { DataTable } from '@/components/tables/DataTable/DataTable';
import { EntityKind } from '@/types/schema';

import { RowData } from './FlatBeneficiaryTable.types';
import { getColumns, getRows } from './FlatBeneficiaryTable.utils';
import { TrustBeneficiariesList_BeneficiaryFragment } from './graphql/TrustBeneficiariesList.fragments.generated';

interface FlatBeneficiaryTableProps {
  heading?: string;
  beneficiaries: TrustBeneficiariesList_BeneficiaryFragment[];
  entityKind?: EntityKind;
  rows?: RowData[];
}

export function FlatBeneficiaryTable({
  heading,
  beneficiaries,
  entityKind,
  rows: rowsExternal,
}: FlatBeneficiaryTableProps) {
  const columns = useMemo(() => {
    return getColumns({ heading, entityKind });
  }, [heading, entityKind]);

  const rows = useMemo(() => {
    if (rowsExternal) {
      return rowsExternal;
    }

    return getRows(beneficiaries, entityKind);
  }, [beneficiaries, entityKind, rowsExternal]);

  return (
    <DataTable
      columns={columns}
      rows={rows}
      hideFooterPagination
      pagination={false}
      columnHeaderHeight={40}
      unstable_rowSpanning
      // Presentation-only, read-only table: the rows aren't clickable and the
      // slide is a static deliverable, so the default per-row hover highlight
      // and column sorting are both misleading affordances.
      rowHoverVariant="transparent"
      disableColumnSorting
      style={{
        border: 'none',
      }}
    />
  );
}
